import { render } from "./Sanchan1.vue?vue&type=template&id=f1db43b2&scoped=true"
import script from "./Sanchan1.vue?vue&type=script&lang=js"
export * from "./Sanchan1.vue?vue&type=script&lang=js"

import "./Sanchan1.vue?vue&type=style&index=0&id=f1db43b2&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-f1db43b2"

export default script